const state = {
  groups: [],
  selectedGroup: {},
};

const getters = {
  groups: (state) => state.groups,
  selectedGroup: (state) => state.selectedGroup,
};

const actions = {
  async fetchCustomerGroups({ commit }, { id }) {
    const response = await this._vm.$http.get(`/restapi/users/${id}/groups/`);

    response.data.data = response.data.data.map((group) => {
      if (group.disable === "FALSE") {
        return { ...group, disable: "ENABLED" };
      }
      return group;
    });

    commit("setGroups", response.data);
  },

  async fetchCustomerGroup({ commit, state }, { id, groupId }) {
    const response = await this._vm.$http.get(
      `/restapi/users/${id}/groups/${groupId}`
    );

    const index = state.groups.findIndex(
      (group) => group.id === response.data.id
    );

    if (index === -1) {
      commit("addGroup", response.data);
    } else {
      commit("updateGroup", { idx: index, group: response.data });
    }
    commit("setSelectedGroup", response.data);
  },

  async createCustomerGroup({ commit }, { group }) {
    const response = await this._vm.$http.post(
      "/restapi/users/${id}/groups/",
      group
    );
    commit("addGroup", response.data);
  },

  async updateCustomerGroup({ commit }, { id, group, groupId }) {
    const response = await this._vm.$http.put(
      `/restapi/users/${id}/groups/${groupId}`,
      {
        policyid:
          group.policy_id === null || group.policy === "None"
            ? ""
            : group.policy_id,
        description: group.description,
      }
    );
    commit("updateGroup", response.data);
  },

  async updateCustomerGroupsWeight({ commit }, { userId, groups }) {
    const req = {};
    let idx = 1;
    for (const group of groups) {
      req[`${group.id}`] = {
        method: "PUT",
        path: `users/${userId}/groups/${group.id}`,
        parameters: {
          policyid: group.policy_id,
          name: group.name,
          weight: idx,
        },
      };
      idx++;
    }
    await this._vm.$http.post("/restapi/batch", req);
    commit("updateGroup", "");
  },

  async deleteCustomerGroup({ commit }, { id, groupId }) {
    const response = await this._vm.$http.delete(
      `/restapi/users/${id}/groups/${groupId}`
    );
    commit("deleteGroup", response.data);
  },
};

const mutations = {
  setGroups: (state, data) => (state.groups = data.data),
  setSelectedGroup: (state, data) => (state.selectedGroup = data),
  addGroup: (state, data) => state.groups.push(data),
  updateGroup: (state, data) => (state.groups[`${data.idx}`] = data.group),
  deleteGroup: (state, data) =>
    (state.groups = state.groups.filter((group) => group.id !== data.id)),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
